export enum LabImportValidationCode {
  AmbiguousTargetMapping = "AMBIGUOUS_TARGET_MAPPING",
  DuplicateMappingId = "DUPLICATE_MAPPING_ID",
  DuplicateProfileName = "DUPLICATE_PROFILE_NAME",
  DuplicateTarget = "DUPLICATE_TARGET",
  InvalidDate = "INVALID_DATE",
  InvalidMapping = "INVALID_MAPPING",
  InvalidProfileRule = "INVALID_PROFILE_RULE",
  InvalidSampleTime = "INVALID_SAMPLE_TIME",
  InvalidValue = "INVALID_VALUE",
  MissingDate = "MISSING_DATE",
  MissingMapping = "MISSING_MAPPING",
  MissingProfileRule = "MISSING_PROFILE_RULE",
  MissingTarget = "MISSING_TARGET",
  MissingValue = "MISSING_VALUE",
  NondetectUnresolved = "NONDETECT_UNRESOLVED",
  OutOfScope = "OUT_OF_SCOPE",
  OverlappingTargetMapping = "OVERLAPPING_TARGET_MAPPING",
  UnitMismatch = "UNIT_MISMATCH",
}
